import fs from "fs/promises";
import path from "path";

import { EnvxSchema } from "../../src/types";
import { createMetaJson } from "../../src/utils/createMetaJson";

export const createMetaJsonFile = async (
  fullSchema: EnvxSchema,
  metaFilePath: string
) => {
  const metaJsonContent = createMetaJson(fullSchema);
  await writeFileEnsureDir(metaFilePath, metaJsonContent);
};

export function escapeEnvValue(value: string): string {
  const cleanValue = value.replace(/\r?\n/g, "\\n");
  if (cleanValue.includes('"') && !cleanValue.includes("'")) {
    return `'${cleanValue}'`;
  } else {
    return '"' + cleanValue.replace(/\\/g, "\\\\").replace(/"/g, '\\"') + '"';
  }
}

// func(writeFileEnsureDir) => check FOLDER have is dont have CREATE
export async function writeFileEnsureDir(filePath: string, content: string) {
  const dir = path.dirname(filePath);
  try {
    await fs.mkdir(dir, { recursive: true });
  } catch (err) {
    throw new Error(
      `Failed to create directory "${dir}" for file "${filePath}": ${
        err instanceof Error ? err.message : String(err)
      }`
    );
  }

  try {
    await fs.writeFile(filePath, content);
  } catch (err) {
    throw new Error(
      `Failed to write file "${filePath}": ${
        err instanceof Error ? err.message : String(err)
      }`
    );
  }
}
